import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { formatSeconds } from './flowBuilderModel';

const plainToolName = (id) => String(id || '').split('.').pop().replace(/[_-]+/g, ' ');

/** The tools an AI step's skill called, in order, with the arguments and a short result. */
export default function ToolCallList({ calls, title = 'Tools the AI called' }) {
  return (
    <Box data-testid="flow-test-tool-calls" sx={{ mb: 1 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontWeight: 700, mb: 0.5 }}>
        {title}
      </Typography>
      <Stack spacing={0.75}>
        {calls.map((call, i) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={`${call.tool}-${i}`}
            data-testid="flow-test-tool-call"
            data-success={call.success ? 'true' : 'false'}
            sx={{
              border: 1, borderColor: call.success ? 'divider' : 'error.light', borderRadius: 1.5, p: 1,
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
              {call.success
                ? <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
                : <ErrorIcon sx={{ fontSize: 16, color: 'error.main' }} />}
              <Typography variant="body2" fontWeight={600}>{plainToolName(call.tool)}</Typography>
              {call.durationMs != null && (
                <Typography variant="caption" color="text.secondary">{formatSeconds(call.durationMs / 1000)}</Typography>
              )}
            </Stack>
            {call.args && call.args !== '{}' && (
              <Typography variant="caption" component="div" sx={{ fontFamily: 'monospace', wordBreak: 'break-word', mt: 0.5 }}>
                {`Asked with ${call.args}`}
              </Typography>
            )}
            {(call.result || call.error) && (
              <Typography
                variant="caption"
                component="div"
                color={call.error ? 'error.main' : 'text.secondary'}
                sx={{
                  fontFamily: 'monospace', wordBreak: 'break-word', mt: 0.5, maxHeight: 96, overflow: 'auto',
                }}
              >
                {call.error ? `Failed: ${call.error}` : `Got ${call.result}`}
              </Typography>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
